import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

import {firstLetterUpperCased, fullName} from '../../../lib/tools'

const initials = invite => `${firstLetterUpperCased(invite.firstName)}${firstLetterUpperCased(invite.lastName)}`

// The contacts screens list everyone a user has named; a recovery only ever lists the ones holding a
// piece, and has nothing to offer for any of them beyond saying where they stand.
const KeyHolders = ({holders, chip}) => (
  <Stack className='key-holders' component='div'>
    {
      holders.map(invite => (
        <Stack
          key={invite.id}
          className='recovery-contact'
          component='div'
          sx={{
            alignItems: {sm: 'center'},
            bgcolor: 'Background',
            flexDirection: {xs: 'column', sm: 'row'},
            justifyContent: 'space-between'
          }}>
          <Stack className='summary' component='div' sx={{flexDirection: 'row'}}>
            <Avatar className='avatar'>{initials(invite)}</Avatar>
            <Stack className='details' component='div'>
              <Typography className='name' variant='body1'>{fullName(invite)}</Typography>
              <Typography className='content' variant='body2'>{invite.email}</Typography>
            </Stack>
          </Stack>
          <Stack className='controls' component='div' direction='row'>
            <Chip className='status' size='small' label={chip.label} color={chip.color} />
          </Stack>
        </Stack>
      ))
    }
  </Stack>
)

KeyHolders.propTypes = {
  holders: PropTypes.array.isRequired,
  chip: PropTypes.object.isRequired
}

export default KeyHolders
